module.exports = __webpack_public_path__ + "static/media/icon_07.fa5e60e4.png";